export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-900 text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info with Logo in White Container */}
          <div>
            <div className="bg-white rounded-xl p-4 inline-block mb-6">
              <img 
                src="https://lirp.cdn-website.com/3dbb45be/dms3rep/multi/opt/o--2846-29-1920w.png" 
                alt="A-One Solid Surfacing Logo" 
                className="h-16 w-auto"
              />
            </div>
            <p className="text-gray-400 mb-6 leading-relaxed">
              Expert countertop fabrication and installation serving Salt Lake County for over 30 years.
            </p>
            <div className="flex space-x-4">
              <a href="https://facebook.com/people/A-One-Solid-Surfacing/100064070738064/?locale=hi_IN" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-amber-600 transition-colors">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a href="https://instagram.com/a_one_solid_surfacing/?hl=en" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-amber-600 transition-colors">
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a href="https://yelp.com/biz/a-one-solid-surfacing-west-valley-city" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-amber-600 transition-colors">
                <i className="ri-yelp-fill text-xl"></i>
              </a>
              <a href="https://www.google.com/maps/place/A-One+Solid+Surfacing/@40.713888,-111.9529183,597m/data=!3m2!1e3!4b1!4m6!3m5!1s0x87528efdfb390ae9:0xb91dbd9faaf9113!8m2!3d40.713888!4d-111.9529183!16s%2Fg%2F1v3dslz4!5m1!1e1?entry=tts" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-amber-600 transition-colors">
                <i className="ri-google-fill text-xl"></i>
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-bold mb-6">Services</h3>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('services')} className="text-gray-400 hover:text-amber-500 transition-colors">
                  Residential Countertops
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('services')} className="text-gray-400 hover:text-amber-500 transition-colors">
                  Commercial Countertops
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('services')} className="text-gray-400 hover:text-amber-500 transition-colors">
                  Porcelain Countertops
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('services')} className="text-gray-400 hover:text-amber-500 transition-colors">
                  Solid Surface Counters
                </button>
              </li>
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-6">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('why-choose')} className="text-gray-400 hover:text-amber-500 transition-colors">
                  Why Choose Us
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('gallery')} className="text-gray-400 hover:text-amber-500 transition-colors">
                  Gallery
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('testimonials')} className="text-gray-400 hover:text-amber-500 transition-colors">
                  Reviews
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('service-areas')} className="text-gray-400 hover:text-amber-500 transition-colors">
                  Service Areas
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('faq')} className="text-gray-400 hover:text-amber-500 transition-colors">
                  FAQ
                </button>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-bold mb-6">Contact</h3>
            <ul className="space-y-4">
              <li>
                <a href="tel:801-706-1610" className="flex items-start space-x-3 text-gray-400 hover:text-amber-500 transition-colors">
                  <i className="ri-phone-line text-xl mt-1"></i>
                  <span>801-706-1610</span>
                </a>
              </li>
              <li>
                <a href="tel:801-803-0804" className="flex items-start space-x-3 text-gray-400 hover:text-amber-500 transition-colors">
                  <i className="ri-phone-line text-xl mt-1"></i>
                  <span>801-803-0804</span>
                </a>
              </li>
              <li>
                <a 
                  href="https://www.google.com/maps/place/A-One+Solid+Surfacing/@40.713888,-111.9529183,597m/data=!3m2!1e3!4b1!4m6!3m5!1s0x87528efdfb390ae9:0xb91dbd9faaf9113!8m2!3d40.713888!4d-111.9529183!16s%2Fg%2F1v3dslz4!5m1!1e1?entry=tts"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-start space-x-3 text-gray-400 hover:text-amber-500 transition-colors"
                >
                  <i className="ri-map-pin-line text-xl mt-1"></i>
                  <span>2580 Decker Lake Blvd Suite 800, West Valley City, UT 84119</span>
                </a>
              </li>
            </ul>

            {/* Hours */}
            <div className="mt-6">
              <h4 className="font-semibold mb-3">Business Hours</h4>
              <div className="text-sm text-gray-400 space-y-1">
                <div>Mon - Thu: 8:00 AM - 5:00 PM</div>
                <div>Friday: 8:00 AM - 11:00 PM</div>
                <div>Sat - Sun: Appointment Only</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-gray-400 text-sm">
              © 2026 A-One Solid Surfacing. All rights reserved.
            </div>
            <div className="flex items-center space-x-6 text-sm text-gray-400">
              <span>Licensed & Insured</span>
              <span>•</span>
              <span>OSHA Compliant</span>
              <span>•</span>
              <span>30+ Years Experience</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}